import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { ThemeProvider, applyStoredTheme } from "./theme";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Toaster } from "@/components/ui/sonner";
import "./index.css";
import "./app.css";

// Reflect the stored theme onto <html> before the first paint. The strict CSP
// forbids an inline <script> in index.html, so this runs as the first thing in
// the bundle instead — early enough to avoid a theme flash in practice.
applyStoredTheme();

const rootEl = document.getElementById("root");
if (rootEl) {
  createRoot(rootEl).render(
    <StrictMode>
      <ThemeProvider>
        <TooltipProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
          <Toaster />
        </TooltipProvider>
      </ThemeProvider>
    </StrictMode>,
  );
}
